// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Breadcrumb, BreadcrumbItem, UncontrolledAlert, Alert } from 'reactstrap';
import PropTypes from 'prop-types';

type PageTitleProps = {
    breadCrumbItems: PropTypes.object,
    title: string,
};

/**
 * PageTitle
 */
class PageTitle extends Component {
    static defaultProps = {
        hideError: false
    };

    constructor(props) {
        super(props);
        this.toggleError = this.toggleError.bind(this);

        this.state = {
            hideError: false
        };
    }

    toggleError() {
        this.setState({
            hideError: true,
        });
    };

    componentDidMount = () => {
    };

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <div className="page-title-box">
                            {this.props.breadCrumbItems != null && this.props.breadCrumbItems.length > 0 &&
                                <div className="page-title-right">
                                    <Breadcrumb>
                                        <BreadcrumbItem>
                                            <Link to="/">Home</Link>
                                        </BreadcrumbItem>
                                        {this.props.breadCrumbItems.map((item, index) => {
                                            return item.active ? (
                                                <BreadcrumbItem active key={index}>
                                                    {item.label}
                                                </BreadcrumbItem>
                                            )
                                                : (
                                                    <BreadcrumbItem key={index}>
                                                        <Link to={item.path}>{item.label}</Link>
                                                    </BreadcrumbItem>
                                                );
                                        })}
                                    </Breadcrumb>
                                </div>
                            }
                            <h4 className="page-title">{this.props.title}</h4>
                        </div>
                    </Col>
                </Row>
                {this.props.error === true && (
                    <Row>
                        <Col>
                            <UncontrolledAlert color='danger' key='1'>
                                <i className="dripicons-wrong mr-2" /> An error has occurred loading the data. Please reload the page or contact <a href={`mailto:CustomerSupport@AerCap.com`}>AerCap Customer Support</a>
                            </UncontrolledAlert>
                        </Col>
                    </Row>
                )}
            </React.Fragment>
        );
    }
}

export default PageTitle;
